export const URL = {
  article: (slug: string) => `/article/${slug}`,
  search: (query: string) => `/search?${new URLSearchParams({ query }).toString()}`,
};
